<template>
  <div class="bg" v-loading="loadingLogin">
    <el-form
      :model="loginForm"
      :rules="rules2"
      ref="loginForm"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-container"
    >
      <h3 class="title">system</h3>
      <el-form-item prop="account">
        <el-input
          type="text"
          v-model="loginForm.loginName"
          auto-complete="off"
          placeholder="account"
        ></el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input
          type="password"
          v-model="loginForm.loginPassword"
          auto-complete="off"
          placeholder="password"
        ></el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input
          v-model="loginForm.captcha"
          auto-complete="off"
          placeholder="valid code"
          style="width: 150px; float: left"
          @keyup.enter.native="handleSubmit2"
        ></el-input>
        <img :src="captchaPic" style="float: right" @click="showCaptcha" />
      </el-form-item>
      <div
        style="
          text-align: left;
          color: red;
          margin-top: 15px;
          margin-bottom: 15px;
        "
      >
        {{ errorMsg }}
      </div>
      <el-form-item style="width: 100%">
        <el-button
          type="primary"
          style="width: 100%"
          @click.native.prevent="handleSubmit2"
          :loading="logining"
        >
          login
        </el-button>
        <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
      </el-form-item>
    </el-form>

    <footer id="tgContact">
      <!-- <h3>认准cashpay官方认证联系人</h3>
      <a target="view_window" href="https://t.me/yxrs93">@yxrs93</a>&nbsp;
      <a target="view_window" href="https://t.me/ycty911">@ycty911</a> -->
      <!-- <a target="view_window" href="https://cashpag.com">关于我们  cashpag.com</a>&nbsp; -->
    </footer>
    <!-- <iframe
      v-if="isIframe"
      id="iframeItem"
      :src="iframeSrc"
      frameborder="0"
    ></iframe> -->

    <loginDia
      :is-show-login-dialog.sync="isShowLoginDialog"
      :url="url"
      :msg="msg"
    ></loginDia>
    <loginGoogleDia
      :is-show-google-auth-dialog.sync="isShowGoogleAuthDialog"
      :url="url"
      :msg="msg"
    ></loginGoogleDia>

</div>
</template>

<script>

import loginDia from './loginDialog'
import loginGoogleDia from './LoginGoogleAuth'

import md5 from 'js-md5'
import { __promisify__ } from 'glob'

export default {
  components: {
    loginDia,
    loginGoogleDia
  },
  data() {
    return {
      logining: false,
      loginForm: {
        loginName: '',
        loginPassword: '',
        captcha: '',
        captchaKey: '',
      },
      rules2: {
        loginName: [
          { required: true, message: 'input account', trigger: 'blur' },
        ],
        loginPassword: [
          { required: true, message: 'input password', trigger: 'blur' },
        ],
      },
      checked: true,
      captchaPic: '',
      errorMsg: '',
      interval: null,
      iframeSrc: '',
      isIframe: false,
      loadingLogin: false,
      isShowLoginDialog: false,
      isShowGoogleAuthDialog: false,
      url: '',
      msg: '',
    }
  },
  methods: {
    handleReset2() {
      this.$refs.loginForm.resetFields()
    },
    handleSubmit2(ev) {
      let _this = this
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.logining = true
          //NProgress.start();
          let loginParams = {
            loginName: this.loginForm.loginName,
            // loginPassword: md5(this.loginForm.loginPassword),
            loginPassword: this.loginForm.loginPassword,
            sysId: _this.$store.state.sysId,
            captchaCode: this.loginForm.captcha,
            captchaKey: this.loginForm.captchaKey,
            loginVersion: 'v5',
            noTgAuth: 'v1',
          }
          this.axios
            .post('/auth/authInfo', loginParams)
            .then(res => {
              this.logining = false
              if (res.code === 200) {
                this.errorMsg = ''
                this.loadingLogin = true

                this.$notify({
                  title: '提示',
                  message: "账号验证成功",
                  type: 'success',
                  onClose: () => {
                  },
                })

                if (res.data.token) {
                  console.log("no_tg_auth_begin...........")
                  this.loginSuccess(res);
                  return;
                }

                if (res.data.sent == 'googleAuth') {
                  console.log("googleAuth........")

                  this.msg = res.msg;
                  this.url = res.data.authCode;
                  this.isShowGoogleAuthDialog = true

                } else {
                  console.log("tgAuth........")

                  this.url = res.data.showUrl;
                  this.msg = res.msg;
                  this.isShowLoginDialog = true

                  let _that = this
                  this.loginData(res.data.authCode)
                  this.$nextTick(() => {
                    _that.interval = setInterval(() => {
                      _that.loginData(res.data.authCode)
                    }, 2500)
                  })
                }
      
              } else {
                this.errorMsg = res.msg
                this.showCaptcha()
              }
            })
            .catch(() => {
              this.logining = false
            })
        } else {
          return false
        }
      })
    },
    showCaptcha() {
      this.$axios.post('/captcha/show', {}).then(res => {
        this.captchaPic = 'data:image/png;base64,' + res.img
        this.loginForm.captchaKey = res.key
      })
    },
    loginData(authCode) {
      let _that = this
      this.$axios
        .get('/auth/getLoginData', {
          params: { loginName: this.loginForm.loginName, authCode: authCode },
        })
        .then(res => {
          if (res.data.sent == 'stop') {
            clearInterval(_that.interval)
            this.$router.push('/login')
            this.loadingLogin = false
            this.loginForm = {
              loginName: '',
              loginPassword: '',
              captcha: '',
              captchaKey: '',
            }
            this.showCaptcha()
            // location.reload()
          }
          if (res.data.sent == 'success') {
            clearInterval(_that.interval)
            this.loginSuccess(res);
          }
        })
    },

    loginSuccess(res) {
      this.$store.commit('setIsLogin', true)
      this.$store.commit('setUserId', res.data.userId)
      this.$store.commit('setUserName', res.data.userName)
      this.$store.commit('setRoutes', res.data.routes)
      this.$store.commit('setToken', res.data.token)
      this.$store.commit('setProdStatus', res.data.prodStatus)
      this.$store.commit('setRoleId', res.data.roleId)
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      this.loadingLogin = false
      this.isShowLoginDialog = false
      this.$router.push('/')
      // console.log("bbbbbbbbbbbbbbbbbb")
    }

  },
  created() {
    this.showCaptcha()
  },
}
</script>

<style lang="scss" scoped>
.login-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 0 auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: rgba(0, 0, 0, 0.5);
  /*border: 1px solid #eaeaea;*/
  /*box-shadow: 0 0 12px #9e9e9e;*/
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -230px 0 0 -175px;

  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #ffffff;
  }

  .remember {
    float: left;
    margin-bottom: 15px;
  }
}

.bg {
  background: url('../assets/bg.jpg') no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  width: 100vw;
  height: 100vh;
  text-align: center;

  #tgContact {
    text-align: center;
    color: #ffffff;
    position: absolute;
    bottom: 24px;
    width: 100%;
    h3 {
      margin: 10px 0;
    }
  }
}
#iframeItem {
  position: fixed;
  top: 0;
  left: 50%;
  width: 500px;
  height: 100%;
  z-index: 10;
  margin-left: -250px;
}
</style>